import React from 'react'

const UDD = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 268.04 93.85"
      {...props}>
      <title>Universidad del Desarrollo</title>
      <g>
        <path
          d="M0,49.57C0,64.94,8.93,93.85,45.94,93.85H91l0-74.47H71.14c0,16.58,0,55.55,0,55.55H47.56c-15.56,0-24.14-7.12-26.56-18-.82-3.84-1.11-6.57-1.11-16.07L19.87,0H0Z"
          fill="#004987"
        />
        <path
          d="M246.81,74.94H192.59c-.05-.38-.12-.75-.17-1.13V20.55c21.31,0,49.53,15.08,54.39,54.39m-74.26,0H118.16V20.55c21.3,0,49.53,15.08,54.39,54.39M268,92.77c0-44.4-19.54-96-95.46-92.61V26.45C158,9.63,134.7-1.46,98.27.16V93.83l94.16,0,.14,0,74.16,0a1.65,1.65,0,0,0,.89-.27,1.28,1.28,0,0,0,.42-.81"
          fill="#004987"
        />
      </g>
    </svg>
  )
}

export default UDD
